// Form helper function
function fillHidden(hiddenname) {
  var checkboxes = document.querySelectorAll(
    '[hidden-data="' + hiddenname + '"]',
  );
  var hiddenfield = document.getElementById(hiddenname); 
  hiddenfield.value = "";
  var i;
  for (i = 0; i < checkboxes.length; i++) {
    var x = checkboxes[i];
    if (x.checked) {
      if (hiddenfield.value == "") {
        hiddenfield.value = x.value;
      } else {
        hiddenfield.value = hiddenfield.value + ", " + x.value;
      }
    }
  }
}

// Price Calculator
class PriceCalculator {
  constructor(pricingUrl) {
    this.pricingUrl = pricingUrl;
    this.pricing = null;
    this.formatSelect = null;
    this.optionCheckboxes = [];
    this.priceDisplay = null;
    this.priceContainer = null;
    this.init();
  }

  init() {
    fetch(this.pricingUrl)
      .then(r => r.json())
      .then(data => {
        this.pricing = data;
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup());
        } else {
          this.setup();
        }
      })
      .catch(() => {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup());
        } else {
          this.setup();
        }
      });
  }

  setup() {
    this.formatSelect = document.getElementById('format-select');
    this.optionCheckboxes = document.querySelectorAll('.option-checkbox');
    this.priceDisplay = document.getElementById('price-amount');
    this.priceContainer = document.getElementById('price-calculator');

    if (this.formatSelect) {
      this.formatSelect.addEventListener('change', () => this.updatePrice());
    }

    this.optionCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => this.updatePrice());
    });
  }

  updateOptionLabels(sizeId) {
    this.optionCheckboxes.forEach(checkbox => {
      const label = checkbox.closest('label');
      if (!label) return;
      const priceSpan = label.querySelector('.option-price');
      if (!priceSpan) return;
      if (!sizeId || !this.pricing) { priceSpan.textContent = ''; return; }
      const key = checkbox.getAttribute('data-option-key');
      if (!key || !this.pricing.options[key]) { priceSpan.textContent = ''; return; }
      const opt = this.pricing.options[key];
      const price = opt.flat !== undefined ? opt.flat
        : (opt.prices && opt.prices[sizeId] !== undefined ? opt.prices[sizeId] : null);
      priceSpan.textContent = price !== null ? ` (+${price}$)` : '';
    });
  }

  updatePrice() {
    if (!this.formatSelect || this.formatSelect.selectedIndex === 0) {
      if (this.priceContainer) this.priceContainer.style.display = 'none';
      this.updateOptionLabels(null);
      return;
    }

    const selectedOption = this.formatSelect.options[this.formatSelect.selectedIndex];
    const sizeId = selectedOption.getAttribute('data-size');
    this.updateOptionLabels(sizeId);

    let total = 0;
    let exact = true;

    if (this.pricing && sizeId && this.pricing.base[sizeId] !== undefined) {
      total += this.pricing.base[sizeId];
    } else {
      exact = false;
    }

    this.optionCheckboxes.forEach(checkbox => {
      if (!checkbox.checked) return;
      const key = checkbox.getAttribute('data-option-key');
      if (!key || !this.pricing || !this.pricing.options[key]) {
        exact = false;
        return;
      }
      const opt = this.pricing.options[key];
      if (opt.flat !== undefined) {
        total += opt.flat;
      } else if (opt.prices && sizeId && opt.prices[sizeId] !== undefined) {
        total += opt.prices[sizeId];
      } else {
        exact = false;
      }
    });

    if (this.priceContainer) this.priceContainer.style.display = 'block';
    if (this.priceDisplay) {
      this.priceDisplay.textContent = (exact ? '' : '~') + total + '$';
    }
  }
}

// Color picker for SVG shape coloring with model selection
class ColorPicker {
  constructor() {
    this.maxColors = 5;
    this.maxColorsTracked = 5;
    this.selectedColors = [];
    this.colorToSlot = new Map();
    this.currentSvgUrl = null;
    this.currentSvgElement = null;
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupListeners());
    } else {
      this.setupListeners();
    }
  }

  setupListeners() {
    // Color checkboxes
    const checkboxes = document.querySelectorAll('.color-picker input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => this.handleColorChange(e.target));
    });

    // Model radio buttons — use class selector so it works regardless of the translated name attribute
    const modelRadios = document.querySelectorAll('.model-radio');
    modelRadios.forEach(radio => {
      radio.addEventListener('change', (e) => this.handleModelChange(e.target));
    });

    // Load initial SVG only if one is already selected
    const checkedModel = document.querySelector('.model-radio:checked');
    if (checkedModel) {
      this.currentSvgUrl = checkedModel.getAttribute('data-svg');
      this.loadInlineSVG(this.currentSvgUrl);
    }
  }

  async handleModelChange(radio) {
    const newSvgUrl = radio.getAttribute('data-svg');
    if (newSvgUrl === this.currentSvgUrl) return;

    // Store current colors
    const savedColors = this.selectedColors.filter(slot => slot !== null);

    // Load new SVG
    this.currentSvgUrl = newSvgUrl;
    await this.loadInlineSVG(newSvgUrl);

    // Count shapes in new SVG
    const newShapeCount = this.countColorableShapes();

    // Always maintain the maximum color slots (never reduce)
    this.maxColorsTracked = Math.max(this.maxColorsTracked, newShapeCount, savedColors.length);
    this.maxColors = this.maxColorsTracked;
    this.selectedColors = new Array(this.maxColors).fill(null);
    this.colorToSlot.clear();

    // Reapply all saved colors to slots
    savedColors.forEach((colorData, index) => {
      this.selectedColors[index] = colorData;
      this.colorToSlot.set(colorData.colorId, index);

      if (index < newShapeCount) {
        this.updateSVGShape(index, colorData.color);
      }
    });

    this.updateUI();
  }

  countColorableShapes() {
    if (!this.currentSvgElement) return 5;
    const colorableShapes = this.getColorableShapes();
    const count = colorableShapes.length;
    return count > 0 ? count : 5;
  }

  handleColorChange(checkbox) {
    const colorId = checkbox.id;

    if (checkbox.checked) {
      const color = checkbox.getAttribute('data-color');
      if (color) {
        this.addColor(colorId, color, checkbox);
        this.updateUI();
      }
    } else {
      this.removeColor(colorId);
      this.updateUI();
    }
  }

  addColor(colorId, color, checkbox) {
    if (this.colorToSlot.has(colorId)) {
      return;
    }

    const emptySlot = this.selectedColors.findIndex(slot => slot === null);

    if (emptySlot !== -1) {
      this.selectedColors[emptySlot] = { colorId, color };
      this.colorToSlot.set(colorId, emptySlot);
      this.updateSVGShape(emptySlot, color);
    } else {
      checkbox.checked = false;
    }
  }

  removeColor(colorId) {
    const slot = this.colorToSlot.get(colorId);
    if (slot !== undefined) {
      this.selectedColors[slot] = null;
      this.colorToSlot.delete(colorId);
      this.updateSVGShape(slot, 'white');
    }
  }

  updateSVGShape(slotIndex, color) {
    if (!this.currentSvgElement) return;

    const shapes = this.getColorableShapes();

    if (slotIndex < shapes.length) {
      const shape = shapes[slotIndex];
      shape.setAttribute('fill', color);

      if (color !== 'white') {
        shape.style.fillOpacity = '1';
        shape.removeAttribute('stroke');
        shape.removeAttribute('stroke-width');
      } else {
        shape.setAttribute('stroke', 'black');
        shape.setAttribute('stroke-width', '2');
      }
    }

    this.updateSVGShadow();
  }

  updateSVGShadow() {
    if (!this.currentSvgElement) return;

    const currentShapeCount = this.countColorableShapes();

    let allColored = true;
    for (let i = 0; i < currentShapeCount; i++) {
      if (!this.selectedColors[i] || this.selectedColors[i] === null) {
        allColored = false;
        break;
      }
    }

    if (allColored && currentShapeCount > 0) {
      this.currentSvgElement.style.filter = 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.4))';
    } else {
      this.currentSvgElement.style.filter = 'none';
    }
  }

  getColorableShapes() {
    if (!this.currentSvgElement) return [];

    const allShapes = this.currentSvgElement.querySelectorAll('rect, circle, path, polygon, ellipse');

    return Array.from(allShapes).filter(shape => {
      const fill = shape.getAttribute('fill');
      const stroke = shape.getAttribute('stroke');
      const tagName = shape.tagName.toLowerCase();

      if (fill === 'none') return false;
      if (fill && fill !== 'none') return true;

      if ((tagName === 'circle' || tagName === 'rect' || tagName === 'ellipse') && stroke) {
        return true;
      }

      if (tagName === 'path' && stroke && !shape.hasAttribute('fill')) {
        return false;
      }

      return true;
    });
  }

  async loadInlineSVG(svgUrl) {
    const imgElement = document.querySelector('.svg-preview img, .svg-preview svg');
    if (!imgElement) {
      console.warn('SVG preview container not found');
      return;
    }

    try {
      const response = await fetch(svgUrl);
      const svgText = await response.text();
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
      const svgElement = svgDoc.querySelector('svg');

      if (!svgElement) {
        console.error('Could not parse SVG');
        return;
      }

      svgElement.setAttribute('data-color-picker', 'true');
      svgElement.style.maxWidth = '100%';
      svgElement.style.height = 'auto';

      const container = imgElement.parentElement;
      container.innerHTML = '';
      container.appendChild(svgElement);

      this.currentSvgElement = svgElement;
    } catch (error) {
      console.error('Error loading SVG:', error);
    }
  }

  updateUI() {
    const checkboxes = document.querySelectorAll('.color-picker input[type="checkbox"]');
    const allFilled = this.selectedColors.every(slot => slot !== null);

    checkboxes.forEach(checkbox => {
      const label = checkbox.parentElement;
      const isSelected = this.colorToSlot.has(checkbox.id);

      if (allFilled && !isSelected) {
        label.style.opacity = '0.3';
        label.style.pointerEvents = 'none';
      } else {
        label.style.opacity = '1';
        label.style.pointerEvents = 'auto';
      }
    });

    // Keep hidden Colors field in sync (important when max colors overflows and a box is auto-unchecked)
    fillHidden('Colors');
  }
}

// Visualization Link Builder
// Builds a URL with current form selections so the email receiver can preview the design.
class VisualizationLinkBuilder {
  constructor() {
    this.baseUrl = 'https://lepointvisible.com/pages/votre-courtepointe';
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    const update = () => this.update();
    document.querySelectorAll('.model-radio').forEach(r => r.addEventListener('change', update));
    document.querySelectorAll('.piqure input[type="radio"]').forEach(r => r.addEventListener('change', update));
    document.querySelectorAll('.color-picker input[type="checkbox"]').forEach(cb => cb.addEventListener('change', update));
    document.querySelectorAll('.option-checkbox').forEach(cb => cb.addEventListener('change', update));
    const formatSelect = document.getElementById('format-select');
    if (formatSelect) formatSelect.addEventListener('change', update);
  }

  update() {
    const params = new URLSearchParams();

    // model: just the value (e.g. "Bergerie"); the viz page maps it to its SVG URL via Liquid
    const model = document.querySelector('.model-radio:checked');
    if (model) params.set('model', model.value);

    const stitch = document.querySelector('.piqure input[type="radio"]:checked');
    if (stitch) params.set('stitch', stitch.value);

    // colors: in slot order (slot 0 → shape 0, slot 1 → shape 1, …)
    // Read from ColorPicker's selectedColors array so the order always matches SVG shapes.
    const hexColors = (window._colorPickerInstance
      ? window._colorPickerInstance.selectedColors
      : []
    ).filter(Boolean).map(s => (s.color || '').replace(/^#/, '')).filter(Boolean);
    if (hexColors.length) params.set('colors', hexColors.join(','));

    const formatSelect = document.getElementById('format-select');
    if (formatSelect && formatSelect.selectedIndex > 0) {
      const sizeId = formatSelect.options[formatSelect.selectedIndex].getAttribute('data-size');
      if (sizeId) params.set('size', sizeId);
    }

    // options: boolean bitmask matching the 9 option checkboxes in DOM order (e.g. 1,0,0,1,0,0,0,0,0)
    const optionCheckboxes = document.querySelectorAll('.option-checkbox');
    if (optionCheckboxes.length) {
      params.set('options', Array.from(optionCheckboxes).map(cb => cb.checked ? '1' : '0').join(','));
    }

    const linkField = document.getElementById('VisualisationLink');
    if (linkField) linkField.value = this.baseUrl + '?' + params.toString();

    const returnTo = document.getElementById('ReturnTo');
    if (returnTo) returnTo.value = '/pages/sur-mesure-confirmation?' + params.toString();
  }
}

// Initialize
const colorPicker = new ColorPicker();
window._colorPickerInstance = colorPicker;
const priceCalculator = new PriceCalculator(window.PRICING_URL || '');
const vizLink = new VisualizationLinkBuilder();
